var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 86,
    viewBox: "0 0 61 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1400_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4627 85.7827L5.63802 78.8927L0.105957 16.8583H60.8938L55.3559 78.883L30.4627 85.7827Z",
    fill: "#264DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6149 74.9335L55.3474 21.9305H30.5V80.5089L50.6149 74.9335Z",
    fill: "#2965F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7881 44.9382L13.4701 52.5464H30.4999V44.9382H12.7881Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4175 29.5389L12.1093 37.1473H30.4998V29.5389H11.4175Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4998 64.6978L30.4664 64.7066L21.9911 62.4187L21.4493 56.3507H13.8101L14.8762 68.2968L30.4647 72.6233L30.4998 72.6136V64.6978Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4121 0H23.6291V3.85352H18.2665V7.70704H23.6291V11.5606H14.4121V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4722 0H34.6892V3.35089H29.3266V4.02106H34.6892V11.7281H25.4722V8.20967H30.8348V7.5395H25.4722V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5327 0H45.7497V3.35089H40.3871V4.02106H45.7497V11.7281H36.5327V8.20967H41.8954V7.5395H36.5327V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.163 44.9383L49.5368 29.5389H30.4736V37.1473H41.1969L40.5044 44.9383H30.4736V52.5465H39.8445L38.9612 62.4138L30.4736 64.7042V72.6196L46.0746 68.2968L46.189 67.0114L47.9773 46.9813L48.163 44.9383Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1400_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 86,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.cd9c68aa26de971707c7888c4e55be61.svg";
export { ForwardRef as ReactComponent };